import { render, staticRenderFns } from "./CompletedOrders.vue?vue&type=template&id=19d06534&scoped=true"
import script from "./CompletedOrders.vue?vue&type=script&lang=js"
export * from "./CompletedOrders.vue?vue&type=script&lang=js"
import style0 from "./CompletedOrders.vue?vue&type=style&index=0&id=19d06534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d06534",
  null
  
)

export default component.exports